// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2awaD","colBig":"styles_colBig__1NcAa","colSmall":"styles_colSmall__1rbbt","shopifyNameWrapper":"styles_shopifyNameWrapper__23iV_"};